import React, { useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import { CloseCircleIcon } from '../../apps/Cards/icons/CloseCircle';
import { usePopup } from '../../hooks/usePopup';
import { useThemeListener } from '../../hooks/useThemeListener';
import './PopupPrivateCoachingForm.scss';

export const PopupPrivateCoachingForm = ({ closeModal }) => {
  const [iFrameHeight, setIFrameHeight] = useState(0);
  const iframeRef = useRef();
  function handleClose(e) {
    closeModal();
    e?.stopPropagation();
  }

  const handleTheme = () => {
    const isDarkTheme = document.body.classList.contains('pc-theme-dark');
    if (isDarkTheme) {
      iframeRef.current?.contentDocument?.body?.classList.add('pc-theme-dark');
    } else {
      iframeRef.current?.contentDocument?.body?.classList.remove(
        'pc-theme-dark'
      );
    }
  };

  useThemeListener(handleTheme);

  const onLoad = () => {
    setTimeout(() => {
      setIFrameHeight(
        iframeRef?.current?.contentDocument?.body?.scrollHeight || 840 + 'px'
      );
      handleTheme();
    }, 200);
  };

  usePopup(handleClose);

  return ReactDOM.createPortal(
    <div className="PopupPrivateCoachingForm">
      <div
        className="PopupPrivateCoachingForm__backdrop"
        onClick={handleClose}
      />

      <div className="PopupPrivateCoachingForm__window">
        <div className="PopupPrivateCoachingForm__wrapper">
          <iframe
            ref={iframeRef}
            id="coaching-form"
            onLoad={onLoad}
            title="coaching-form"
            className="PopupPrivateCoachingForm__form"
            style={{
              // height: iFrameHeight,
              height: '400px',
            }}
            src={`${window.dataWP.config.endpoints.home_url}/form-iframe-privatecoaching/`}
          />
          <button
            className="PopupPrivateCoachingForm__close"
            onClick={handleClose}
          >
            <CloseCircleIcon />
          </button>
        </div>
      </div>
    </div>,
    document.getElementById('pc-popup-portal')
  );
};
